module.exports = __webpack_public_path__ + "img/DE01039.b79cc993.png";